var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-3 px-4 md:px-10 text-white",class:{
        'bg-blue-500': _vm.status == 'webmoney',
        'bg-green-500': _vm.status == 'system',
        'bg-red-500': _vm.status == 'danger',
    }},[(_vm.status == 'webmoney')?_c('p',[_vm._v(" "+_vm._s(_vm.$t("site.webmoney_site_status"))+" ")]):(_vm.status == 'system')?_c('p',[_vm._v(" "+_vm._s(_vm.$t("site.system_site_status"))+" ")]):(_vm.status == 'danger')?_c('p',[_vm._v(" "+_vm._s(_vm.$t("site.danger_site_status"))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }